import React from 'react';
import BookingDetailsFieldToggle from "./BookingDetailsField/BookingDetailsFieldToggle";
import EquipmentTypeSelect from "./EquipmentTypeSelect";

interface EquipmentSelectClasses {
  root: string;
  label: string;
}

interface BookingDetailsEquipmentTypeSelectProps {
  editMode: boolean;
  onToggleEditMode: (value: boolean, event?: React.MouseEvent) => void;
  value: string;
  onChange?: (value: string) => void;
  options: string[];
  className?: string;
  selectClasses: EquipmentSelectClasses;
  disableBookingChanges: boolean;
  readOnly: boolean;
}

const BookingDetailsEquipmentTypeSelect = (props: BookingDetailsEquipmentTypeSelectProps) => {

  const {
    editMode,
    onToggleEditMode,
    value,
    onChange,
    options,
    className,
    selectClasses,
    disableBookingChanges,
    readOnly
  } = props;

  const handleToggleEdit = (toggleValue: boolean, event?: React.MouseEvent) => {
    if (!readOnly) {
      onToggleEditMode(toggleValue, event);
    }
  };

  return (
    <BookingDetailsFieldToggle title={'Vehicle Type'} open={editMode && !readOnly} onChange={handleToggleEdit}
                               value={value}
                               className={className} disableToggle={readOnly}>
      <EquipmentTypeSelect
        selection={value}
        setSelection={onChange}
        assetTypeList={options}
        disableBookingChanges={disableBookingChanges}
        classes={selectClasses}
      />
    </BookingDetailsFieldToggle>
  );
};

export default BookingDetailsEquipmentTypeSelect; 
